import Blog from "../../component/blog/Blog";
import MBlog from "../../component/mobile/blog/MBlog";




const BLOG=()=>{
  return(
    <div className="BLOG">
      {window.innerWidth>1000 && <Blog/>}
      {window.innerWidth<1000 && <MBlog/>}
    </div>
  )
}


export default BLOG;